export default {
    HASH: 'hash',
    CVE: 'cve',
    IP: 'ip',
    DOMAIN: 'domain',
    URL: 'url'
};
